const sortByContinent = (a, b, currentContinent) => {
    const continentPriority = (currentContinent === 'europe' ? 1 : -1);

    if (a.continent === 'europe' && b.continent !== 'europe') {
        return -1 * continentPriority;
    } else if (b.continent === 'europe' && a.continent !== 'europe') {
        return 1 * continentPriority;
    }

    return 0;
};

export { sortByContinent };
